

































































































import { Carousel, Slide } from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import trainers, { ITrainer } from '~/components/kickboxing/content/kickboxers/trainers';
import { windowMatchMediaMixin } from '~/mixins/matchMedia';

export default {
  name: 'Kickboxing_Trainers',
  mixins: [windowMatchMediaMixin],
  components: {
    FCImage,
    Carousel,
    Slide,
  },
  data() {
    return {
      current: trainers[1],
      content: {
        trainers,
      },
    };
  },
  methods: {
    onTrainerCardClick(trainer: ITrainer) {
      this.current = trainer;
    },
  },
};
